import React, { FC, useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import CheckboxField from 'buyside/components/presentation/Fields/checkboxField';

const FundProfileDisplayField: FC<{
  currentEmployers: { id: string; hasFundProfile: boolean }[];
  researchType: 'Idea' | 'Macro/Thematic Report';
}> = ({ currentEmployers, researchType }) => {
  const [anonymous, employerId] = useWatch({
    name: ['anonymous', 'employerId']
  });

  const selectedEmployerHasFundProfile = useMemo(
    () => currentEmployers.some(({ id, hasFundProfile }) => id === employerId && hasFundProfile),
    [currentEmployers, employerId]
  );

  const isDisabled = anonymous || !selectedEmployerHasFundProfile;

  return (
    <CheckboxField
      disabled={isDisabled}
      label={`FEATURE THIS ${researchType} ON MY FUND PROFILE`}
      name="fundProfileDisplay"
      size="small"
    />
  );
};

export default FundProfileDisplayField;
